import { render, staticRenderFns } from "./DocumentosDigitales.vue?vue&type=template&id=98dc9a36&scoped=true&"
import script from "./DocumentosDigitales.vue?vue&type=script&lang=js&"
export * from "./DocumentosDigitales.vue?vue&type=script&lang=js&"
import style0 from "./DocumentosDigitales.vue?vue&type=style&index=0&id=98dc9a36&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98dc9a36",
  null
  
)

export default component.exports